import { Link, useParams } from 'react-router-dom';
import { ArrowLeftIcon, ArrowPathIcon } from '@heroicons/react/24/outline';
import Card, { CardHeader, CardBody } from '@/components/ui/Card';
import Button from '@/components/ui/Button';
import Badge from '@/components/ui/Badge';

export default function DistDeliveryDetailPage() {
  const { id } = useParams();

  return (
    <div className="space-y-6 animate-fade-in">
      <Link to="/distribution/deliveries" className="inline-flex items-center gap-2 text-slate-500 hover:text-slate-700">
        <ArrowLeftIcon className="w-4 h-4" />
        Back to Deliveries
      </Link>

      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold text-slate-800">Delivery #{id}</h1>
          <Badge variant="success" className="mt-2">PUSHED</Badge>
        </div>
        <Button variant="outline" leftIcon={<ArrowPathIcon className="w-4 h-4" />}>Retry</Button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <Card>
          <CardHeader title="Delivery Details" />
          <CardBody className="space-y-4">
            <div><p className="text-sm text-slate-500">Book</p><p className="font-medium">Le Petit Prince</p></div>
            <div><p className="text-sm text-slate-500">Platform</p><p className="font-medium">Apple Books</p></div>
            <div><p className="text-sm text-slate-500">Status</p><p className="font-medium">PUSHED</p></div>
            <div><p className="text-sm text-slate-500">Created</p><p className="font-medium">Jan 15, 2024 10:30 AM</p></div>
          </CardBody>
        </Card>

        <Card>
          <CardHeader title="Timeline" />
          <CardBody>
            <div className="space-y-3">
              <div className="flex gap-3"><span className="text-slate-400">10:30</span><span>Delivery created</span></div>
              <div className="flex gap-3"><span className="text-slate-400">10:31</span><span>Metadata validated</span></div>
              <div className="flex gap-3"><span className="text-slate-400">10:32</span><span>Pushed to Apple Books</span></div>
              <div className="flex gap-3"><span className="text-slate-400">10:35</span><span>Confirmation received</span></div>
            </div>
          </CardBody>
        </Card>
      </div>
    </div>
  );
}

